import { Text } from '@wartek-id/text-v1'

import { assetUrl } from 'utils/url'

import type { FC } from 'react'

type DialogConsentReconfirmProps = {
  children?: React.ReactNode
}

export const DialogConsentReconfirm: FC<DialogConsentReconfirmProps> = ({
  children,
}) => {
  return (
    <div className="space-y-4">
      <img
        src={assetUrl('/illustrations/img-document-sync-data.png')}
        alt=""
        height={84}
        width={84}
      />

      <Text variant="display-sm" as="h2">
        Konfirmasi ulang data Tim Kinerja dan Pejabat Penilai Kinerja Anda?
      </Text>

      <Text variant="body-lg" color="subdued">
        Jika diulang, Anda mungkin tidak dapat melanjutkan Pengelolaan Kinerja.
      </Text>

      {children}
    </div>
  )
}
